import React, { FC } from 'react';

const NonResearchPublications: FC = () => {
    return (
        <div>
            <h2>NonResearchPublications</h2>
            <ul>
                <li>Alice Johnson - Project Lead</li>
                <li>Bob Smith - Frontend Developer</li>
                <li>Carol Lee - Backend Developer</li>
                <li>David Kim - UI/UX Designer</li>
            </ul>
        </div>
    );
};

export default NonResearchPublications;